import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayload } from 'app-components/flux/core/resourceStoreTypes';

import type { Dataset, DatasetProps } from './datasetsTypes';

const syncDatasetsPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<DatasetProps>>();
const datasetPayloadCreator = getPayloadCreator<Dataset>();

export const getDatasets = createAction('GET_DATASETS', getPayloadCreator());
export const getDatasetsSuccess = createAction('GET_DATASETS_SUCCESS', syncDatasetsPayloadCreator);
export const getDatasetsFailure = createAction('GET_DATASETS_FAILURE', errorPayloadCreator);

export const createDataset = createAction('CREATE_DATASET', datasetPayloadCreator);
export const createDatasetSuccess = createAction('CREATE_DATASET_SUCCESS', datasetPayloadCreator);
export const createDatasetFailure = createAction('CREATE_DATASET_FAILURE', errorPayloadCreator);

export const deleteDataset = createAction('DELETE_DATASET', datasetPayloadCreator);
export const deleteDatasetSuccess = createAction('DELETE_DATASET_SUCCESS', datasetPayloadCreator);
export const deleteDatasetFailure = createAction('DELETE_DATASET_FAILURE', errorPayloadCreator);

export const updateDataset = createAction('UPDATE_DATASET', datasetPayloadCreator);
export const updateDatasetSuccess = createAction('UPDATE_DATASET_SUCCESS', datasetPayloadCreator);
export const updateDatasetFailure = createAction('UPDATE_DATASET_FAILURE', errorPayloadCreator);

export const datasetPoll = createAction('DATASET_POLL', getPayloadCreator<{ id?: string }>());
export const datasetPollSuccess = createAction('DATASET_POLL_SUCCESS', syncDatasetsPayloadCreator);
export const datasetPollFailure = createAction('DATASET_POLL_FAILURE', errorPayloadCreator);

export const getDatasetEntitlementsSuccess = createAction(
  'GET_DATASET_ENTITLEMENTS_SUCCESS',
  syncDatasetsPayloadCreator,
);
export const getDatasetEntitlementsFailure = createAction('GET_DATASET_ENTITLEMENTS_FAILURE', errorPayloadCreator);
